<template>
  <div class="poster-container" ref="container">
    <div class="poster-img">
      <img :src="backgroundUrl" />
      <!-- <img src="../../assets/img/poster2.png" /> -->
    </div>
    <div class="poster-button-div">
      <input v-model="branchName" type="text" placeholder="请输入所在支行名称" />
      <input v-model="managerName" type="text" placeholder="请输入客户经理姓名" />
      <input v-model="salesAmount" type="text" placeholder="请输入销售金额(以万为单位)" />
      <p v-html="promptText" :class="{'hidden': isUndoneFlag}"></p>
      <button class="create" @click="generatePoster">生成喜报</button>
    </div>
    <div class="mask-div" v-show="isShowPoster">
      <div class="generated-img">
        <img :src="url" alt=""/>
        <p @click="closePoster"><span>×</span></p>
      </div>
      <p class="download-text">长按下载图片</p>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import { CHANNEL_TYPE_BANK } from '../../constants/GlobalConstants'

export default{
  data () {
    return {
      CHANNEL_TYPE_BANK: CHANNEL_TYPE_BANK,
      branchName: '',
      managerName: '',
      salesAmount: '',
      promptText: '提示文字仅为数字',
      isUndoneFlag: true,
      isShowPoster: false,
      url: '',
      productCode: '',
      productName: '鹏扬景浦一年持有期',
      backgroundUrl: ''
    }
  },
  mounted () {
    this.productCode = this.$route.query.productCode
    console.log('this.productCode: ', this.productCode)
    if (!this.productCode) {
      this.productCode = '013041'
    }
    this.getContentHeight()
    this.getProductByCode()
    this.configWxShareHandler()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getContentHeight () {
      let listContainerHeight = window.screen.height
      this.$refs.container.style.height = listContainerHeight + 'px'
    },
    async getProductByCode () {
      console.log(this.productCode)
      let result = await this.axios.get('/api/product/queryProduct?productCode=' + this.productCode + '&channelType=' + this.CHANNEL_TYPE_BANK)
      if (result && result.data.errorCode === 0) {
        this.productName = result.data.data.productShortName
        this.backgroundUrl = result.data.data.imgUrl
      } else {
        this.productCode = '013041'
      }
    },
    async generatePoster () {
      this.isUndoneFlag = true
      if (this.branchName === '' || this.managerName === '' || this.salesAmount === '') {
        this.isUndoneFlag = false
        this.promptText = '请将贺卡内容填写完整'
        return false
      }

      const loading = this.$loading({
        lock: true,
        text: '喜报生成中...请稍后...',
        spinner: 'none',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'poster-loading'
      })

      let o = {
        accountManager: this.managerName,
        bankName: this.branchName,
        salesAmount: this.salesAmount,
        productCode: this.productCode,
        channelType: this.CHANNEL_TYPE_BANK
      }
      try {
        let result = await this.axios.post('/api/product/generateProductGoodNews', o)
        if (result && result.data.errorCode === 0) {
          this.url = result.data.data
          setTimeout(_ => {
            this.isShowPoster = true
            loading.close()
          }, 500)
        } else {
          this.url = ''
          loading.close()
          Messagebox.alert('生成喜报失败')
        }
      } catch (err) {
        loading.close()
        return false
      }
    },
    closePoster () {
      this.isShowPoster = false
    },
    configWxShareHandler () {
      let wxConfigFlag = sessionStorage.getItem('wxConfigFlag')
      if (wxConfigFlag !== 'true') {
        // console.log('wait config complete')
        window.setTimeout(this.configWxShareHandler, 100)
      }
      let host = window.location.protocol + '//' + window.location.host + '/'
      let iconPath = '/static/img/poster-icon1.jpg'
      // console.log('icon path :' + host + iconPath)
      wx.updateAppMessageShareData({
        title: '鹏扬基金 喜报来啦！',
        desc: this.productName, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: host + iconPath, // 分享图标
        success: function () {
          // 设置成功
          console.log('微信分享成功')
        }
      })
      wx.updateTimelineShareData({
        title: '鹏扬基金 喜报来啦！',
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: host + iconPath, // 分享图标
        success: function () {
          // 设置成功
          console.log('朋友圈分享成功')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/theme/iram_default_variables";
input::-moz-placeholder{
  font-size: 14px;
  color: #fff;
}
input::placeholder{
  font-size: 14px;
  color: #fff;
}
input::-webkit-input-placeholder{
  font-size: 14px;
  color: #fff;
}
.poster-container {
  position: relative;
  background: #c41111;
}
.poster-img {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    margin-top: -3%;
  }
}
.poster-button-div {
  position: absolute;
  bottom: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  input {
    width: 225px;
    height: 34px;
    margin-bottom: 10px;
    background: #9B0800;
    border: none;
    border-radius: 5px;
    outline: none;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }
  p {
    font-size: 12px;
    color: #fff;
    margin-bottom: 8px;
  }
  .hidden {
    visibility: hidden;
  }
  .create {
    width: 145px;
    height: 30px;
    border: none;
    border-radius: 20px;
    background-image: linear-gradient(#F9DB98, #FFFFFF, #ECAD53);
    outline: none;
    font-size: 15px;
    font-weight: 700;
    font-family: 'Microsoft YaHei', 'Arial Narrow', Arial, sans-serif;
    color: #701a1b;
  }
}
.mask-div {
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:10;
  background:rgba(0,0,0,0.7);
}
.generated-img {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  img {
    position: absolute;
    top: 7%;
    width: 75%;
  }
  p {
    position: absolute;
    display: inline-block;
    background: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    right: 7%;
    top: 4%;
    opacity: 0.85;
  }
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -2px;
    width: 40px;
    height: 40px;
    font-size: 40px;
  }
}
.download-text {
  position: absolute;
  bottom: 3%;
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: center;
}
</style>
<style lang="scss">
.poster-loading {
  .el-loading-text {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/poster-generator/Index.vue